<button class="back" (click)="backToTable()" [attr.tooltip-value]="'Back' | translate" tooltip-class="right">
	<i class="fa fa-long-arrow-left"></i>
</button>
